/**
 * Created by wwei on 2018-10-16.
 */

import React, { Component } from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import Constants, {Lock_Status, OPERATOR_TYPES, PRODUCT_SHOW_NAME, Permissions} from '../../commons/Constants';
import {permissionCheck} from "../../commons/CommonUtils";
import Loading from "../../commons/Loading";
import ToolBar from "../../commons/ToolBar";
import {Checkbox, Popover, Row, Col, Select, Tooltip} from 'antd';

class PolicyTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            filterValue: null
        };
    }

    productFormat = (cell, row, enumObject) => {
        return <a onClick={() => this.props.openConfigPanel(row["policyid"])}><div>{enumObject[cell[0]]}</div></a>
    }

    tenantFormat = (cell, row) => {
        if (cell === null) {
            return "Global";
        }
        const tenants = this.props.tenants;
        const tmp = tenants.filter(t => t.tenantId === cell);
        if (tmp.length === 1) {
            const tenant = tmp[0];
            const tip = (
                <div>
                    <Row>
                        <Col span={6}>
                            ID:
                        </Col>
                        <Col span={18}>
                            {tenant ? tenant.tenantId : "Unknown"}
                        </Col>
                    </Row>
                    <Row>
                        <Col span={6}>
                            Name:
                        </Col>
                        <Col span={18} style={{wordBreak: 'break-all'}}>
                            {tenant ? tenant.companyName : "Unknown"}
                        </Col>
                    </Row>
                    <Row>
                        <Col span={6}>
                            Domain:
                        </Col>
                        <Col span={18} style={{wordBreak: 'break-all'}}>
                            {tenant ? tenant.tenantDomain : "Unknown"}
                        </Col>
                    </Row>
                    <Row>
                        <Col span={6}>
                            Email:
                        </Col>
                        <Col span={18} style={{wordBreak: 'break-all'}}>
                            {tenant ? tenant.adminEmail : "Unknown"}
                        </Col>
                    </Row>
                </div>
            );
            return <Tooltip title={tip}>{tenant.companyName}</Tooltip>;
        } else {
            return "";
        }
    }

    tenantFilterType = (cell, row) => {
        if (cell === null) {
            return "Global";
        }
        const tenants = this.props.tenants;
        const tmp = tenants.filter(t => t.tenantId === cell);
        if (tmp.length === 0) {
            return "Global";
        }
        const tenant = tmp[0];
        return tenant.companyName;
    }

    operatorFormat = (cell, row) => {
        return row && row.version ? OPERATOR_TYPES[row.version.operator] : "";
    }

    versionFormat = (cell, row) => {
        return row && row.version ? row.version.value : "";
    }

    actionFormat = (cell, row, extraData, rowIndex) => {
        const { lockStatus, policyList } = this.props;
        const { filterValue } = this.state;
        const showAction = permissionCheck([Permissions.SoftwareUpgrade.EDIT]) && filterValue === null;
        return ( showAction ? (
            <div className="btn-action">
                {(rowIndex > 0) &&
                <button disabled={lockStatus === Lock_Status.lock_lock}
                        className={lockStatus === Lock_Status.lock_lock ? "btn up-icon action-icon-disabled" : "btn up-icon"}
                        onClick={() => this.props.onSwapPolicy(policyList[rowIndex]["policyid"], policyList[rowIndex - 1]["policyid"])}>
                    <i title="Move Up"></i>
                </button>}
                {rowIndex < policyList.length - 1 &&
                <button disabled={lockStatus === Lock_Status.lock_lock}
                        className={lockStatus === Lock_Status.lock_lock ? "btn down-icon action-icon-disabled" : "btn down-icon"}
                        onClick={() => this.props.onSwapPolicy(policyList[rowIndex]["policyid"], policyList[rowIndex + 1]["policyid"])}>
                    <i title="Move Down"></i>
                </button>}
            </div>
        ) : "");
    }

    onFilterChange = obj => {
        if (Object.keys(obj).length === 0) {
            this.setState({ filterValue: null });
        } else {
            const filterValue = obj.products.value;
            this.setState({ filterValue });
        }
    }

    trClassFormat = (row, rowIndex) => {
        if (row.policyid === this.props.selectedPolicy) {
            return "table_selected_row";
        }
    };

    render() {
        const { filterValue } = this.state;
        let { showSlide, loading, height, policyList } = this.props;
        if (filterValue !== null) {
            policyList = policyList.filter(p => p.products[0] === filterValue);
        }
        const options = {
            defaultSortName: 'priority',
            defaultSortOrder: 'desc',
            toolBar: this.props.toolBar,
            noDataText: loading ? <Loading /> : "No policy found.",
            searchDelayTime: 500,
            onFilterChange: this.onFilterChange
        }

        return (
            <BootstrapTable ref="table" data={ policyList } search={ true } options={ options }
                            multiColumnSearch={ true } bodyStyle={{ overflowX: 'hidden' }}
                            maxHeight={height} trClassName={this.trClassFormat}
                            striped hover condensed>
                <TableHeaderColumn dataField='policyid' isKey
                                   hidden={ true }
                                   searchable={ false }>ID</TableHeaderColumn>
                <TableHeaderColumn dataField='tid'
                                   hidden={ true }
                                   dataFormat={this.tenantFilterType}/>
                <TableHeaderColumn dataField='priority'
                                   width="5%"
                                   dataSort={ true }>Priority</TableHeaderColumn>
                <TableHeaderColumn dataField='products'
                                   dataFormat={this.productFormat}
                                   formatExtraData={ PRODUCT_SHOW_NAME }
                                   width="26%"
                                   filter={ { type: 'SelectFilter', options: PRODUCT_SHOW_NAME } }>Products</TableHeaderColumn>
                <TableHeaderColumn dataField='tid'
                                   width="17%"
                                   dataFormat={this.tenantFormat}
                                   dataSort={ true }
                                   hidden={ showSlide }
                                   searchable={ false }>Tenant</TableHeaderColumn>
                <TableHeaderColumn dataField='version'
                                   dataFormat={this.operatorFormat}
                                   width="6%"
                                   hidden={ showSlide }>Operator</TableHeaderColumn>
                <TableHeaderColumn dataField='version'
                                   dataFormat={this.versionFormat}
                                   width="8%"
                                   hidden={ showSlide }
                                   filterFormatted>Version</TableHeaderColumn>
                <TableHeaderColumn dataField='urlPath'
                                   width="30%"
                                   hidden={ showSlide }>URL Path</TableHeaderColumn>
                <TableHeaderColumn dataField='tid'
                                   dataFormat={this.actionFormat}
                                   width="85px"
                                   hidden={ showSlide }>Action</TableHeaderColumn>
            </BootstrapTable>
        )
    }
}

export default PolicyTable;


// WEBPACK FOOTER //
// ./src/modules/policy/PolicyTable.js